import { type CreateLogbookRecordInput } from '../../API';
import { type FinishedFlightLeg } from '../FlightLegs/FlightLeg';
import { type LogbookInstrumentApproach } from './LogbookInstrumentApproach';

type OmittedFields =
    | '_version'
    | 'aircraftMake'
    | 'aircraftRegistration'
    | 'airplaneSeMeMcc'
    | 'arrivalPlace'
    | 'arrivalTime'
    | 'contactId'
    | 'copilotTime'
    | 'crewId'
    | 'date'
    | 'deleted'
    | 'departurePlace'
    | 'departureTime'
    | 'dualTime'
    | 'id'
    | 'instructorTime'
    | 'instrumentApproachDetails'
    | 'isFstd'
    | 'legId'
    | 'picName'
    | 'picTime';

export type InLegLogbook = Omit<CreateLogbookRecordInput, OmittedFields> & {
    instrumentApproachDetails: LogbookInstrumentApproach[];
    catIILandings?: number | null;
    rld80Landings?: number | null;
};

export const createEmptyInLegLogbook = (): InLegLogbook => ({
    totalFlightTime: null,
    landingsTotal: null,
    landingsNight: null,
    nightTime: null,
    ifrTime: null,
    remarks: null,
    crossCountryTime: null,
    instrumentActualTime: null,
    instrumentSimulatedTime: null,
    instrumentApproachDetails: [],
    holdings: null,
    catIILandings: null,
    rld80Landings: null,
});

export function inLegLogbookToRecord(
    inLeg: InLegLogbook,
    leg: FinishedFlightLeg
): Omit<CreateLogbookRecordInput, 'contactId' | 'crewId' | 'id'> {
    return {
        date: leg.timeOut.toISOString(),
        deleted: false,
        legId: leg.id,
        editableByUserIds: inLeg.editableByUserIds,
    };
}
